(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
  const initMagazineBlogCarousels = (root = document) => {
    root.querySelectorAll('.magazine-blog__list--carousel').forEach((list) => {
      if (list.dataset.carouselReady === 'true') return;
      list.dataset.carouselReady = 'true';

      const section = list.closest('.magazine-blog');
      if (!section) return;

      const prevButton = section.querySelector('[data-magazine-blog-control="prev"]');
      const nextButton = section.querySelector('[data-magazine-blog-control="next"]');

      const updateButtons = () => {
        const maxScroll = Math.max(list.scrollWidth - list.clientWidth, 0);
        if (prevButton) prevButton.disabled = list.scrollLeft <= 1;
        if (nextButton) nextButton.disabled = list.scrollLeft >= maxScroll - 1;
      };

      const scrollByPage = (direction) => {
        list.scrollBy({ left: direction * list.clientWidth * 0.85, behavior: 'smooth' });
      };

      prevButton?.addEventListener('click', () => scrollByPage(-1));
      nextButton?.addEventListener('click', () => scrollByPage(1));
      list.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      window.addEventListener('load', updateButtons);

      if ('ResizeObserver' in window) {
        new ResizeObserver(updateButtons).observe(list);
      }

      list.querySelectorAll('img').forEach((image) => {
        if (image.complete) return;
        image.addEventListener('load', updateButtons, { once: true });
      });

      updateButtons();
      requestAnimationFrame(updateButtons);
    });
  };

  initMagazineBlogCarousels();
  document.addEventListener('shopify:section:load', (event) => initMagazineBlogCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaqContentNav(root) {
      root.querySelectorAll('[data-faq-nav]').forEach((nav) => {
        if (nav.dataset.faqNavReady === 'true') return;
        nav.dataset.faqNavReady = 'true';

        const section = nav.closest('.faq-content');
        if (!section) return;

        const links = [...nav.querySelectorAll('[data-faq-nav-link]')];
        const categories = links
          .map((link) => {
            const id = link.getAttribute('href')?.replace('#', '');
            return id ? section.querySelector('#' + id) : null;
          })
          .filter(Boolean);

        if (!categories.length) return;

        const setActive = (activeLink) => {
          links.forEach((link) => link.classList.toggle('is-active', link === activeLink));
        };

        links.forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            const target = section.querySelector(link.getAttribute('href'));
            if (!target) return;
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setActive(link);
          });
        });

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(
            (entries) => {
              const visible = entries
                .filter((entry) => entry.isIntersecting)
                .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
              if (!visible) return;
              const index = categories.indexOf(visible.target);
              if (index >= 0) setActive(links[index]);
            },
            { rootMargin: '-20% 0px -55% 0px', threshold: [0, 0.25, 0.5, 1] },
          );

          categories.forEach((category) => observer.observe(category));
        }
      });
    }

    initFaqContentNav(document);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target) initFaqContentNav(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setHeaderVisibility(true);

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderVisibility(isVisible) {
      document.documentElement.style.setProperty('--header-is-visible', isVisible ? '1' : '0');
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.setHeaderVisibility(false);
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.setHeaderVisibility(true);
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.setHeaderVisibility(true);
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  if (!customElements.get('collection-banner-description')) {
    customElements.define(
      'collection-banner-description',
      class CollectionBannerDescription extends HTMLElement {
        connectedCallback() {
          this.initialize();
        }

        initialize() {
          const preview = this.querySelector('[data-description-preview]');
          const details = this.querySelector('details');
          const teaser = this.querySelector('[data-description-teaser]');

          if (!preview || !details || !teaser) return;

          const needsToggle = preview.scrollHeight > preview.clientHeight + 1;

          if (!needsToggle) return;

          preview.hidden = true;
          details.hidden = false;

          details.addEventListener('toggle', () => {
            if (details.open) {
              teaser.style.display = 'block';
              teaser.style.overflow = 'visible';
              teaser.style.webkitLineClamp = 'unset';
              teaser.style.webkitBoxOrient = 'unset';
              return;
            }

            teaser.removeAttribute('style');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-overlay-blocks"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const reducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const PARALLAX_SCALE = 1.3;
    const PARALLAX_TRANSLATE = (0.15 * 100) / PARALLAX_SCALE;

    function initMediaOverlayParallax(root) {
      if (reducedMotion) return;
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return;

      root.querySelectorAll('[data-media-overlay-parallax="true"]').forEach((section) => {
        if (section.dataset.parallaxReady === 'true') return;
        section.dataset.parallaxReady = 'true';

        const frame = section.querySelector('.media-overlay-blocks__frame--parallax');
        const image = frame && frame.querySelector('.media-overlay-blocks__image, .media-overlay-blocks__placeholder');
        if (!frame || !image) return;

        let frameId = 0;

        const updateParallax = () => {
          frameId = 0;
          const rect = frame.getBoundingClientRect();
          const viewport = window.innerHeight;

          if (rect.bottom < 0 || rect.top > viewport) return;

          const progress = (viewport - rect.top) / (viewport + rect.height);
          const translate = (progress - 0.5) * 2 * PARALLAX_TRANSLATE;
          image.style.transform = 'scale(' + PARALLAX_SCALE + ') translateY(' + translate + '%)';
        };

        const scheduleUpdate = () => {
          if (frameId) return;
          frameId = window.requestAnimationFrame(updateParallax);
        };

        window.addEventListener('scroll', scheduleUpdate, { passive: true });
        window.addEventListener('resize', scheduleUpdate);
        updateParallax();
      });
    }

    initMediaOverlayParallax(document);
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target) initMediaOverlayParallax(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const nextSectionButton = event.target.closest('[data-action="navigate-next"]');
    if (nextSectionButton) {
      nextSectionButton.closest('.shopify-section')?.nextElementSibling?.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
      return;
    }

    const unmuteButton = event.target.closest('[data-hero-slideshow-unmute]');
    if (unmuteButton) {
      const slide = unmuteButton.closest('.hero-slideshow__slide');
      slide?.querySelectorAll('video').forEach((video) => {
        video.muted = false;
      });
      unmuteButton.hidden = true;
      slide?.querySelector('[data-hero-slideshow-mute]')?.removeAttribute('hidden');
      return;
    }

    const muteButton = event.target.closest('[data-hero-slideshow-mute]');
    if (muteButton) {
      const slide = muteButton.closest('.hero-slideshow__slide');
      slide?.querySelectorAll('video').forEach((video) => {
        video.muted = true;
      });
      muteButton.hidden = true;
      slide?.querySelector('[data-hero-slideshow-unmute]')?.removeAttribute('hidden');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
